var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmilingAnyway({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 23,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M44.1521,45.7678a20.0408,20.0408,0,0,1-17.967-.8385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,31a3,3,0,1,1-3-3,3.0011,3.0011,0,0,1,3,3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,31a3,3,0,1,1-3-3,3.001,3.001,0,0,1,3,3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M44.5416,46.2169a3.6376,3.6376,0,0,1-1.1052-2.5764c-.0405-3.2205,2.9651-6.34,3.0929-6.4712a.6891.6891,0,0,1,.9748-.0123c.1313.1281,3.2143,3.1713,3.2555,6.3924l0,0a3.6626,3.6626,0,0,1-6.2183,2.6673Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmilingAnyway);
export default __webpack_public_path__ + "static/media/SmilingAnyway.bfe11ba9e148c3cb4a4323a507e5950a.svg";
export { ForwardRef as ReactComponent };